export default __webpack_public_path__ + "static/media/alert-tone.dd24668d.mp3";